import { render, staticRenderFns } from "./TargetGroupChannels.vue?vue&type=template&id=20d25af8&scoped=true&"
import script from "./TargetGroupChannels.vue?vue&type=script&lang=js&"
export * from "./TargetGroupChannels.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupChannels.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TargetGroupChannels.vue?vue&type=style&index=1&id=20d25af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d25af8",
  null
  
)

export default component.exports